import { useMemo } from 'react';
import { useTranslation } from 'next-i18next/pages';
import { SearchApi } from '@pkgs/api';
import { useAuth } from '@ev-tech/user-account-modules';
import { useStatusMessage } from '@ev-tech/ui-core-components/StatusMessageProvider';
import { alertVariants } from '@ev-tech/ui-core-components/Alert';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { SEARCH_API_CONFIG } from '@/consts/search-api';

export const useSearchApi = () => {
  const { showMessage } = useStatusMessage();
  const { t } = useTranslation(TRANSLATION_NAMESPACE.common);
  const { getToken } = useAuth();

  const searchApi = useMemo(() => {
    return new SearchApi({
      ...SEARCH_API_CONFIG,
      getToken,
      onError: (error) => {
        SEARCH_API_CONFIG.onError(error);
        showMessage(t('search.error.message'), { alertType: alertVariants.error });
      },
    });
  }, [showMessage, t, getToken]);

  return searchApi;
};
